<template>
  <OffCanvas ref="storeTasksCanvas" :title="'Список задач'">
    <h6 class="mb-1"></h6>
    <div class="row">
      <table class="table table-bordered">
        <tbody>
        <tr v-for="(task, index) in tasks" :key="index">
          <td>
            {{ getTaskDisplayName(task.task_name) }}
            {{ formatDateTime(task.start_time) }}
          </td>
          <td>
            {{ getStatus(task.status) }}
            {{ formatDateTime(task.end_time) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </OffCanvas>
</template>

<script>
import OffCanvas from "@/components/page/OffCanvas.vue";
import {getTasks} from "@/api/tasks";
import {user} from "@/data/user";

export default {
  name: 'StoreTasks',
  components: {OffCanvas},
  data() {
    return {
      tasks: [],
      companyTimezone: 'UTC'
    }
  },
  props: {
    store_id: {
      type: String,
      required: true
    }
  },
  async mounted() {
    // Получаем информацию о компании через user.getCompanyInfo()
    const companyInfo = await user.getCompanyInfo();
    this.companyTimezone = companyInfo.timezone || 'UTC';
  },
  methods: {
    open() {
      this.$refs.storeTasksCanvas.open()
      this.updateTasks()
    },
    async updateTasks() {
      const res = await getTasks({
        company_id: await user.getActiveCompany(),
        store_id: this.store_id
      })
      this.tasks = res.data
    },
    getStatus(status){
      const statuses = {
        'FAILED': 'Ошибка',
        'STARTED': 'Запущена',
        'COMPLETED': 'Выполнена',
        'success': 'Выполнена',
        'PROCESSING': 'В работе'
      }
      return (status && statuses[status]) || status || 'Неизвестный статус';
    },
    getTaskDisplayName(taskName) {
      const names = {
        'get_offers': 'Импорт цен',
        'import_products': 'Импорт товаров',
        'get_orders': 'Загрузка заказов',
        'run_strategy_task': 'Запуск стратегии',
        'sync_discounts': 'Синхронизация цен витрины'
      }
      return names[taskName] || taskName;
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      // Обрезаем миллисекунды и смещение, если есть
      // Пример: 2025-07-14T16:00:00.160636+03:00 -> 2025-07-14T16:00:00
      const match = dateString.match(/^(.{19})/);
      const clean = match ? match[1] : dateString;
      const date = new Date(clean.replace('T', ' '));
      if (isNaN(date.getTime())) return dateString;
      const pad = n => n.toString().padStart(2, '0');
      return `${pad(date.getDate())}.${pad(date.getMonth()+1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    }
  }
}
</script>